import Enumerable from "linq";
import { IXElementContentsObjectBean, IXElementContentsObjectRelationalBean, IXElementContentsObjectRelationalItemBean } from "../../../beans";
import { ArrayComplexTranslator } from "../../values";

export class RelationReplacer {
  replaceBeans(source: IXElementContentsObjectBean, action: string, ...beans: IXElementContentsObjectRelationalBean[]): void {
    const itemBeans = Enumerable.from(beans)
      .where(b => !!b && !!b["@action"] && (b["@action"] === action) && !!b.relationalitem)
      .select(b => this.arrayComplex.from(b.relationalitem))
      .aggregate([] as IXElementContentsObjectRelationalItemBean[], (r, i) => r.concat(i));
    const relationBean = (0 < itemBeans.length)
      ? {
        "@action": action,
        "relationalitem": this.arrayComplex.to(itemBeans),
      }
      : undefined as IXElementContentsObjectRelationalBean;
    this.replaceBean(source, action, relationBean);
  }

  replaceBean(source: IXElementContentsObjectBean, action: string, bean: IXElementContentsObjectRelationalBean): void {
    const relations = this.arrayComplex.from(source.relational);
    if (!bean) {
      this.removeRelations(relations, action);
    } else if (!this.replaceRelations(relations, action, bean)) {
      relations.push(bean);
    }
    source.relational = this.arrayComplex.to(relations);
  }

  private removeRelations(source: IXElementContentsObjectRelationalBean[], action: string): boolean {
    return this.processRelations(source, action, (s, i) => s.splice(i, 1));
  }

  private replaceRelations(source: IXElementContentsObjectRelationalBean[], action: string, relation: IXElementContentsObjectRelationalBean): boolean {
    return this.processRelations(source, action, (s, i) => s[i] = relation);
  }

  private processRelations(source: IXElementContentsObjectRelationalBean[], action: string, process: (source: IXElementContentsObjectRelationalBean[], index: number) => void): boolean {
    for (let i = 0; i < source.length; i++) {
      const target = source[i];
      if (target && (target["@action"] === action)) {
        process(source, i);
        return true;
      }
    }
    return false;
  }

  private readonly arrayComplex = new ArrayComplexTranslator();
}
